import { axiosClient } from "../client";

/* The "publish to the 3rd party" endpoint. The backend picks up every product
   that has the 3rd party publish flag on by itself, so the request carries no
   body at all.

   NOTE: replace the path below with the real endpoint once it is confirmed -
   this is the only line that has to change. */
const API_THIRD_PARTY_PUBLISH = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/hubrise/publish`;

/* Sends the publish request. No body is sent with it. */
export const publishThirdParty = (locationId) =>
  axiosClient({
    method: "POST",
    url: API_THIRD_PARTY_PUBLISH(locationId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
    locationId,
  });
